import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import BidCard from '@/components/BidCard.vue'
import { QuoteDetailV2, QuoteDetailV2Bid } from '../models/dto/QuoteDetailV2'
import { InfoModalDetail } from '@/models/InfoModalDetail'
import { InfoModalVariant } from '@/utils/enum'
import InfoModal from './InfoModal.vue'

// Define props using runtime declaration
interface Props {
  bid: QuoteDetailV2Bid
  isElite: boolean
  quote?: QuoteDetailV2 | null
  isBrandedQuoteFlowEnabled: boolean
  isDisplayPartnerUrlEnabled: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'QuoteDetailBidListCharterUpChoice',
  props: {
    bid: null,
    isElite: { type: Boolean },
    quote: null,
    isBrandedQuoteFlowEnabled: { type: Boolean },
    isDisplayPartnerUrlEnabled: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  bid: QuoteDetailV2Bid
  isElite: boolean
  quote?: QuoteDetailV2 | null
  isBrandedQuoteFlowEnabled: boolean
  isDisplayPartnerUrlEnabled: boolean
};



// Convert class property to ref
const isOpen = ref(false)

// Convert class property to constant
const charterupChoiceModalDetail: InfoModalDetail = {
  label: `CharterUP's Choice`,
  shortLabel: `CharterUP's Choice`,
  icon: {
    name: 'charterup_choice',
    color: 'primary',
    viewBox: '0 0 24 24',
  },
  modalVariant: InfoModalVariant.Custom,
  showCharterUPLogo: true,
  showSupportButton: false
}

// Convert getters to computed properties
const operatorName = computed(() => props.bid.companyDBAName)

const quoteId = computed(() => props.quote?.quoteId)

const isPickupInCanada = computed(() =>
  props.quote?.trips?.[0]?.stops?.[0]?.address?.country === 'CA'
)

return { __sfc: true,props, isOpen, charterupChoiceModalDetail, operatorName, quoteId, isPickupInCanada, BidCard, InfoModal }
}

})